<template>
    <components :is="`link-document-item-${data.type}`"
                :data="data"
                class="link-document-item"
                :class="`link-document-item-${data.type}`"
                @debug="$emit('debug')"
                @browse="$emit('browse')"
    />
</template>

<script>
    import LinkDocumentItemText from "./link-document-item-text";
    import LinkDocumentItemSlot from "./link-document-item-slot";
    import LinkDocumentItemDemo from "./link-document-item-demo";
    import LinkDocumentItemTable from "./link-document-item-table";
    import LinkDocumentItemImg from "./link-document-item-img";

    export default {
        name: "link-document-item",
        components: {LinkDocumentItemTable, LinkDocumentItemDemo, LinkDocumentItemSlot, LinkDocumentItemText, LinkDocumentItemImg},
        props: {
            data: {},
        },
    }
</script>

<style lang="scss">
    .link-document-item {

        &.link-document-item-img {
            margin-bottom: 0;
        }

        &.link-document-item-demo {
            margin-bottom: 48px;
        }
    }
</style>
